import { apiClient } from "../api";
import { AboutUs, UpdateAboutUsDto } from "../generated/client";

export const upsertAboutUs = async (data: UpdateAboutUsDto): Promise<AboutUs> => {
    try {
        const response = await apiClient.aboutUs.upsert(data);
        alert("About Us saved successfully");
        return response.data;
    } catch (error) {
        console.error("upsert aboutUs:", error);
        throw error;
    }
};

export const getAboutUs = async (): Promise<AboutUs> => {
    try {
        const response = await apiClient.aboutUs.find();
        return response.data;
    } catch (error) {
        console.error("fetch aboutUs:", error);
        throw error;
    }
};
